import {
	Fragment,
	useEffect,
	useRef,
	useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';

import {
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	Typography,
	Popover,
	ListItemIcon,
} from '@material-ui/core';
import {
	Delete as DeleteIcon,
} from '@material-ui/icons';
import { useConfirm } from 'material-ui-confirm';

import useStyles from './LocationsList.styled';
import RouterNavLink from '../shared/RouterNavLink';
import { useWeather } from '../../hooks/Weather';
import { capitaliseString } from '../../utils';

const DrawerContent = () => {
	const confirm = useConfirm();
	const { pathname } = useLocation();
	const classes = useStyles();
	const { locations, removeLocation } = useWeather();
	const [contextAnchor, setContextAnchor] = useState(null);
	const listEl = useRef(null);

	const handleContextMenuClose = () => setContextAnchor(null);

	const handleContextMenuOpen = (event) => {
		const closestContextMenuOption = event.target.closest('.context-menu-select');
		// console.log(closestContextMenuOption);

		// Only render if the right click occurs within the locationSelector
		if (closestContextMenuOption) {
			event.preventDefault();
			setContextAnchor({
				left: event.pageX,
				top: event.pageY,
				id: closestContextMenuOption.dataset.id,
			});
		}
	};

	const handleRemoveLocation = (location) => {
		handleContextMenuClose();
		confirm({
			title: `Are you sure you want to remove "${location.title}"?`,
			confirmationText: 'Remove',
		})
			.then(() => removeLocation(location));
	};

	useEffect(() => {
		const { current } = listEl;
		current.addEventListener('contextmenu', handleContextMenuOpen);

		return () => current.removeEventListener('contextmenu', handleContextMenuOpen);
	}, [listEl]);

	return (
		<List className={classes.list} ref={listEl}>
			{locations.length === 0 && (
				<ListItem>
					<ListItemText primary="No favourites 😢" />
				</ListItem>
			)}
			{locations.map((location) => (
				<Fragment key={location.id}>
					<ListItem
						button
						className={clsx(classes.listItem, 'context-menu-select')}
						component={RouterNavLink}
						selected={`/${location.id}` === pathname}
						to={`/${location.id}`}
						data-id={location.id}
					>
						<ListItemText
							primary={`${location.city}, ${location.country}`}
							secondary={capitaliseString(location.description)}
						/>
						<ListItemSecondaryAction className={classes.temperature}>
							<Typography variant="h5">{`${location.temperature}\u00B0`}</Typography>
						</ListItemSecondaryAction>
					</ListItem>

					<Popover
						open={contextAnchor?.id === location.id.toString()}
						onClose={handleContextMenuClose}
						anchorReference="anchorPosition"
						anchorPosition={{
							top: contextAnchor?.top || 0,
							left: contextAnchor?.left || 0,
						}}
					>
						<List className={classes.list} dense>
							<ListItem button onClick={() => handleRemoveLocation(location)}>
								<ListItemIcon>
									<DeleteIcon color="error" />
								</ListItemIcon>
								<ListItemText
									className={classes.listItemText}
									primary={`Remove "${location.city}, ${location.country}"`}
								/>
							</ListItem>
						</List>
					</Popover>
				</Fragment>
			))}
		</List>
	);
};

export default DrawerContent;
